import { Card, Typography, Box } from "@mui/material";

const KycPreview = ({ title, previewUrl, fileName }) => {
  if (!previewUrl) return null;

  const isPdf = fileName?.toLowerCase().endsWith(".pdf");

  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>

      {isPdf ? (
        <iframe
          src={previewUrl}
          title={title}
          style={{
            width: "100%",
            height: 250,
            border: "1px solid #ddd",
            borderRadius: 4,
          }}
        />
      ) : (
        <Box
          component="img"
          src={previewUrl}
          alt={title}
          sx={{
            width: "100%",
            maxHeight: 220,
            objectFit: "contain",
            border: "1px solid #ddd",
            borderRadius: 2,
          }}
        />
      )}
    </Card>
  );
};

export default KycPreview;
